"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../../util/GlobalScript.js");

var _react = _interopRequireWildcard(require("react"));

var _v2Stateless = _interopRequireDefault(require("./v2-stateless"));

var _Utils = _interopRequireDefault(require("../../../util/Utils"));

var _underscore = _interopRequireDefault(require("underscore"));

var _Validators = _interopRequireDefault(require("../../../util/Validators"));

var _exifJs = _interopRequireDefault(require("exif-js"));

var _fixOrientation = _interopRequireDefault(require("fix-orientation"));

var _v2Constants = _interopRequireDefault(require("./v2-constants.js"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @name FileUploadStateful
 * @memberof FileUpload
 * @desc This is a wrapper around the stateful (stateless=false) FileUpload to give the user image preview
 *    and error messages without having to implement that logic.
 */
var FileUpload = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FileUpload, _Component);

  var _super = _createSuper(FileUpload);

  function FileUpload() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, FileUpload);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      errorMessage: "",
      thumbnailSrc: _this.props.thumbnailSrc,
      labelAcceptedFileTypes: _this.props.labelAcceptedFileTypes || _this.props.accept.split("image/").join("")
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_fileReadSuccess", function (file, contentUrl) {
      var self = (0, _assertThisInitialized2.default)(_this);

      _this.setState({
        thumbnailSrc: contentUrl
      });

      _this.props.onPreviewReady(contentUrl);

      if (contentUrl && file.type.match(/^image\/jpe?g$/i)) {
        //try to read exif data the base64 data was passed
        _exifJs.default.getData(file, function () {
          if (this.exifdata && this.exifdata.Orientation) {
            //correct and display the image according to the exif orientation
            (0, _fixOrientation.default)(contentUrl, {
              image: true
            }, function (fixedImgContentUrl) {
              self.setState({
                thumbnailSrc: fixedImgContentUrl
              });
              self.props.onPreviewReady(fixedImgContentUrl);
            });
          }
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_processWithHtml5Api", function (file, path) {
      _this.setState({
        fileName: _Utils.default.stripFakePath(path)
      });

      var isValidFileSize = _Validators.default.isValidFileSize(file.size, _this.props.maxFileSizeKb);

      var isValidMimeType = _Validators.default.isValidMimeType(file.type, _this.props.accept);

      try {
        if (!isValidFileSize) {
          _this.resetComponent();

          throw _v2Constants.default.ErrorCodes.TOO_BIG;
        }

        if (!isValidMimeType) {
          _this.resetComponent();

          throw _v2Constants.default.ErrorCodes.WRONG_MIME_TYPE;
        }

        if (_this.props.showThumbnail && file.type.match("image.*")) {
          _Validators.default.readFile(file, _this._fileReadSuccess, _this.props.onError, _v2Constants.default.ErrorCodes.CANT_READ);
        } else {
          _this._processSimple();
        }
      } catch (err) {
        _this.props.onError(err);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_processSimple", function () {
      _this.setState({
        errorMessage: "",
        thumbnailSrc: ""
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_process", function (files, path) {
      if (!files) {
        return;
      }

      if (_this.props.onValidate) {
        var errorMessage = _this.props.onValidate(files[0]);

        if (errorMessage) {
          _this.setState({
            errorMessage: errorMessage
          });

          return;
        }
      }

      if (files && files[0]) {
        if (_Utils.default.isHtmlFileApiSupported()) {
          _this._processWithHtml5Api(files[0], path);
        } else {
          _this._processSimple();
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleChange", function (e) {
      if (_this.props.onChange) {
        _this.props.onChange(e);
      }

      _this._process(e.target.files, e.target.value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleRemove", function () {
      if (_this.props.onRemove) {
        _this.props.onRemove();
      }

      if (_this.props.disabled) {
        return;
      }

      if (_this.props.onValidate) {
        _this.setState({
          errorMessage: _this.props.onValidate()
        });
      }

      _this.resetComponent();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetComponent", function () {
      _this.setState({
        thumbnailSrc: "",
        fileName: ""
      });

      _this.refs.FileUploadStateless.resetComponent();
    });
    return _this;
  }

  (0, _createClass2.default)(FileUpload, [{
    key: "render",
    value: function render() {
      var props = _underscore.default.defaults({
        ref: "FileUploadStateless",
        showFilename: !this.props.showThumbnail,
        onRemove: this._handleRemove,
        onChange: this._handleChange
      }, this.props, this.state);

      return /*#__PURE__*/_react.default.createElement(_v2Stateless.default, props);
    }
  }]);
  return FileUpload;
}(_react.Component);

exports.default = FileUpload;
(0, _defineProperty2.default)(FileUpload, "displayName", "FileUploadStateful");
(0, _defineProperty2.default)(FileUpload, "defaultProps", {
  onPreviewReady: _underscore.default.noop
});
module.exports = exports["default"];